import {Construtor} from './construtor';

export class PeriodicidadeDados implements Construtor<PeriodicidadeDados> {
  public idPeriodicidadeDados: number;
  public descricaoPeriodicidadeDados: string;

  constructor(object?: any) {

    if (object !== undefined) {

      if (object instanceof PeriodicidadeDados) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }

    }

    return this;
  }

  copyObject(periodicidadeDados: PeriodicidadeDados): void {
    this.idPeriodicidadeDados = periodicidadeDados.idPeriodicidadeDados;
    this.descricaoPeriodicidadeDados = periodicidadeDados.descricaoPeriodicidadeDados;
  }

  parseFromJson(periodicidadeDados: any): void {
    this.idPeriodicidadeDados = periodicidadeDados.idPeriodicidadeDados;
    this.descricaoPeriodicidadeDados = periodicidadeDados.descricaoPeriodicidadeDados;
  }

  modeloCompleto(): boolean {
    return this.descricaoPeriodicidadeDados !== undefined;
  }

  getNewInstance(object?: any): PeriodicidadeDados {
    return new PeriodicidadeDados(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/periodicidade-dados.ts